export const isCacheListSchedulesByCarManager = (routeName) => {
  return ['schedule.car.list', 'projects.work_reservations.schedule.detail', 'projects.sales.instructions.detail'].includes(routeName);
}

export const isCacheListSchedulesBySale = (routeName) => {
  return ['schedules', 'projects.work_reservations.schedule.detail_for_sale', 'projects.sales.instructions.detail'].includes(routeName);
}
